import React, { useState } from "react";
import "./CreateStory.css";
import create_story_image from "../assets/create-story.jpg";
import axios from "axios";
import { config } from "../../config/const";
import Modal from "react-modal";

const CreateStory = () => {
  const [prompt, setPrompt] = useState("");
  const [numImages, setNumImages] = useState(1);
  const [story, setStory] = useState(null);
  const [loading, setLoading] = useState(false);
  const [tags, setTags] = useState([]);
  const [title, setTitle] = useState("");
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [newTag, setNewTag] = useState("");
  const [email, setEmail] = useState(localStorage.getItem("email"));
  const [previewImage, setPreviewImage] = useState(null);
  const [thumbnail, setThumbnail] = useState(null);
  const [saveModalIsOpen, setSaveModalIsOpen] = useState(false);
  const [status, setStatus] = useState("public");
  const [postSaveModalIsOpen, setPostSaveModalIsOpen] = useState(false);
  const [storyID, setStoryID] = useState("");

  const handleGenerateStory = async () => {
    setLoading(true);
    setStory(null); // Clear the old story
    setTitle(""); // Clear the old title
    setTags([]); // Clear the old tags
    setThumbnail(null); // Clear the old thumbnail

    const requestBody = {
      email: email,
      prompt: prompt,
      n: parseInt(numImages, 10),
    };
    try {
      const response = await axios.post(
        `${config.backend_url}/user/generateStory`,
        requestBody
      );
      console.log(response.data);
      setStory(response.data);
      //trim the response.data.title so it does't have " at the start and end
      const trimmedTitle = response.data.title.replace(/^"|"$/g, "");
      setTitle(trimmedTitle);
      setTags(response.data.tag ? response.data.tag.split(" ") : []);
    } catch (error) {
      console.error("Error generating story:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleSaveStory = async () => {
    try {
      let storyContent = "";
      for (let i = 0; i < story.content.length; i++) {
        storyContent += story.content[i] + "\n";
      }
      let tagArray = [];
      for (let i = 0; i < tags.length; i++) {
        tagArray.push(tags[i]);
      }
      let storyList = [];
      for (let i = 0, j = 0; i < story.content.length; i += 2, j++) {
        let storyObj = {
          line: story.content[i],
          image: story.images[j],
          id: j,
        };
        storyList.push(storyObj);
      }

      const requestBody = {
        email: email,
        title: title,
        content: storyContent,
        prompt: prompt,
        tag: tagArray,
        status: status,
        thumbnail: story.images[0],
        images: story.images,
        storyList: storyList,
      };
      console.log(requestBody);
      const response = await axios.post(
        `${config.backend_url}/user/save`,
        requestBody
      );
      console.log(response.data);
      setStoryID(response.data.id);
      setPostSaveModalIsOpen(true);
    } catch (error) {
      console.error("Error saving story:", error);
    }
  };

  const handleAddTag = () => {
    setModalIsOpen(true);
  };

  const handleSaveTag = () => {
    if (newTag && !tags.includes(newTag)) {
      setTags([...tags, newTag]);
    }
    setModalIsOpen(false);
    setNewTag("");
  };

  const handleRemoveTag = (tagToRemove) => {
    setTags(tags.filter((tag) => tag !== tagToRemove));
  };

  const handleImageClick = (image) => {
    setPreviewImage(image);
  };

  const closePreviewModal = () => {
    setPreviewImage(null);
  };

  const handleThumbnailSelect = (image) => {
    setThumbnail(image);
  };

  const openSaveModal = () => {
    setSaveModalIsOpen(true);
  };

  const closeSaveModal = () => {
    setSaveModalIsOpen(false);
  };

  const handleSaveAsPublic = () => {
    setStatus("public");
    closeSaveModal();
    handleSaveStory();
  };

  const handleSaveAsPrivate = () => {
    setStatus("private");
    closeSaveModal();
    handleSaveStory();
  };

  const handleCreateMoreStories = () => {
    setPostSaveModalIsOpen(false);
    setPrompt("");
    setNumImages(1);
    setStory(null);
    setTags([]);
    setTitle("");
    setThumbnail(null);
    setStatus("public");
  };

  const handleGoToStoriesPage = () => {
    window.location.href = `/story/${storyID}`;
  };

  return (
    <div className="container_story">
      <div className="side_image_container">
        <img src={create_story_image} alt="Create Story" />
      </div>
      <div className="form_container">
        <div className="inputs_story">
          <div className="input_story">
            <label htmlFor="prompt">Prompt</label>
            <textarea
              id="prompt"
              name="prompt"
              placeholder="Enter your story prompt"
              value={prompt}
              onChange={(e) => setPrompt(e.target.value)}
            />
          </div>
          <div className="input_story">
            <label htmlFor="numImages">Number of Images</label>
            <input
              id="numImages"
              type="number"
              min="1"
              max="10"
              value={numImages}
              onChange={(e) => setNumImages(e.target.value)}
            />
          </div>
          {!story && (
            <button className="submit" onClick={handleGenerateStory}>
              {loading ? "Generating..." : "Generate Story"}
            </button>
          )}
        </div>
        {story && (
          <div className="generated_story">
            <div className="input_story">
              <label htmlFor="title">Title</label>
              <textarea
                id="title"
                name="title"
                placeholder="Title"
                value={title}
                onChange={(e) => setTitle(e.target.value)}
              />
            </div>
            <div className="input_story">
              <label>Tags</label>
              <div className="tags_container">
                {tags.map((tag, index) => (
                  <div key={index} className="tag">
                    {tag}
                    <button onClick={() => handleRemoveTag(tag)}>x</button>
                  </div>
                ))}
                <button className="add_tag_button" onClick={handleAddTag}>
                  Add Tag
                </button>
                <Modal
                  isOpen={modalIsOpen}
                  onRequestClose={() => setModalIsOpen(false)}
                  className="modal"
                  overlayClassName="overlay"
                >
                  <h2>Enter new tag:</h2>
                  <input
                    type="text"
                    value={newTag}
                    onChange={(e) => setNewTag(e.target.value)}
                  />
                  <button className="modal_button" onClick={handleSaveTag}>
                    Save
                  </button>
                  <button
                    className="modal_button"
                    onClick={() => setModalIsOpen(false)}
                  >
                    Cancel
                  </button>
                </Modal>
              </div>
            </div>
            <div className="input_story thumb">
              <label>Images</label>
              <div className="images_container">
                {story.images.map((image, index) => (
                  <div key={index} className="image_wrapper">
                    <img
                      className={`thumbnail ${
                        thumbnail === image ? "selected" : ""
                      }`}
                      src={image}
                      alt={`Story Image ${index + 1}`}
                      onClick={() => handleThumbnailSelect(image)}
                    />
                    <button
                      className="preview_button"
                      onClick={() => handleImageClick(image)}
                    >
                      Preview
                    </button>
                  </div>
                ))}
              </div>
            </div>
            <div className="input_story message">
              <label htmlFor="content">Story Content</label>
              <textarea
                id="content"
                name="content"
                wrap="soft"
                placeholder="Story Content"
                value={story.content}
                readOnly
              />
            </div>
            <button className="submit" onClick={openSaveModal}>
              Save Story
            </button>
            <button className="submit" onClick={handleGenerateStory}>
              Regenerate Story
            </button>
          </div>
        )}
      </div>
      {previewImage && (
        <Modal
          isOpen={true}
          onRequestClose={closePreviewModal}
          className="modal"
          overlayClassName="overlay"
        >
          <img src={previewImage} alt="Preview" className="preview_image" />
          <button className="modal_button" onClick={closePreviewModal}>
            Close
          </button>
        </Modal>
      )}
      {saveModalIsOpen && (
        <Modal
          isOpen={true}
          onRequestClose={closeSaveModal}
          className="modal"
          overlayClassName="overlay"
        >
          <h2>Save Story As</h2>
          <button className="modal_button" onClick={handleSaveAsPublic}>
            Public
          </button>
          {/* <button
            className="modal_button"
            onClick={handleSaveAsPrivate}
            disabled
          >
            Private
          </button> */}
          <button className="modal_button" onClick={closeSaveModal}>
            Cancel
          </button>
        </Modal>
      )}
      {postSaveModalIsOpen && (
        <Modal
          isOpen={true}
          onRequestClose={() => setPostSaveModalIsOpen(false)}
          className="modal"
          overlayClassName="overlay"
        >
          <h2>Story Saved Successfully!</h2>
          <button className="modal_button" onClick={handleCreateMoreStories}>
            Create More Stories
          </button>
          <button className="modal_button" onClick={handleGoToStoriesPage}>
            Go to Stories Page
          </button>
        </Modal>
      )}
    </div>
  );
};

export default CreateStory;
